import { SETTLEMENT_STATUSES } from '../../utils/constants';

export function hasSettlementCompleted(state) {
  return state.settlement.status === SETTLEMENT_STATUSES.carDelivered;
}

export function getActiveLeasesWithoutData(state) {
  const leases = state.settlement.activeLeasesWithoutData;
  return Array.isArray(leases) ? leases : [];
}
